import { Component, Input, Output, EventEmitter } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../../core';
import { ClienteCentralCompraParticipanteHttpService } from './services';
import { ClienteCentralCompraParticipante } from './cliente-central-compra-participante';

@Component({
    selector: 'sgt-cliente-central-compra-participante',
    templateUrl: './cliente-central-compra-participante.component.html',
    styleUrls: ['./cliente-central-compra-participante.component.less']
})
export class ClienteCentralCompraParticipanteComponent {
    /** ID da central de compras */
    @Input() idClienteCentralCompra: number;
    /** Percentual de participação total dos participantes da central de compras */
    @Input() percParticipacaoTotalCentralCompra: number;

    /* Participantes da central de compras **/
    @Input() participantes: ClienteCentralCompraParticipante[];
    @Output() participantesChange = new EventEmitter<ClienteCentralCompraParticipante[]>();
    isLoading: boolean;
    isLoaded: boolean;

    constructor(private messageService: MessageService,
                private clienteCentralCompraParticipanteHttpService: ClienteCentralCompraParticipanteHttpService) { }

    /** Pesquisa os clientes participantes da central de compras */
    search() {
        if (!this.idClienteCentralCompra) {
            return;
        }

        this.isLoading = true;
        this.isLoaded = false;
        this.participantes = [];
        this.clienteCentralCompraParticipanteHttpService.search(this.idClienteCentralCompra)
            .pipe(
                take(1)
            )
            .subscribe(
                participantes => {
                    this.participantes = participantes;
                    this.participantesChange.emit(this.participantes);
                    this.isLoading = false;
                    this.isLoaded = true;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar os participantes da central de compras', error);
                    this.isLoading = false;
                    this.isLoaded = false;
                }
            );
    }
}
